"use client";

import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { makeStore } from "@/redux/store";
import { setLoggedIn } from "@/redux/features/LoginModal/loginModalSlice";
import { isUserAuthenticated } from "@/utils/checkAuthFromCookies";

export default function ReduxProvider({
  children,
  isLoggedIn,
}: {
  children: React.ReactNode;
  isLoggedIn: boolean;
}) {
  const [store] = useState(() => makeStore(isLoggedIn));

  // Cookies can change between the server render and hydration (e.g. the proxy sets
  // authToken on the response), so re-check them on the client after hydrating.
  useEffect(() => {
    const clientLoggedIn = isUserAuthenticated();
    if (store.getState().loginModal.isLoggedIn !== clientLoggedIn) {
      store.dispatch(setLoggedIn(clientLoggedIn));
    }
  }, [store]);

  return <Provider store={store}>{children}</Provider>;
}
